/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_010: Question = {
  id: 'pres-010-taille-moyenne-parcelles',
  oldId: '24',
  title: 'Taille moyenne des parcelles',
  number: '2.10',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};
const question_pres_010__v3: Question = {
  ...question_pres_010,
  frequency: 4,
  number: '2.9',
};

export const question_pres_010_v2: Question = question_pres_010;
export const question_pres_010_v3: Question = question_pres_010__v3;
